import React from 'react';
import Home from './Home';
import Layout from '../../components/Layout';

async function action({ client, store }) {
  const siteSettingsData = store.getState().siteSettings.data || {};
  const title = siteSettingsData.siteTitle || 'Admin Panel';
  const description = siteSettingsData.metaDescription || '';

  return {
    title,
    description,
    component: (
      <Layout>
        <Home />
      </Layout>
    ),
  };
}

export default action;
